<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="less">
html, body, #app {
  width: 100%;
  height: 100%;
  margin: 0;
}
</style>
<style lang="less">
.el-menu-item:focus, .el-menu-item:hover {
  background-color: #faf0e6;
}
.el-button--primary {
  background-color: rgb(220, 20, 60);
  border-color: rgb(220, 20, 60);
}
.el-button:focus, .el-button:hover {
  color: rgba(220, 20, 60, 0.8);
  border-color: rgba(220, 20, 60, 0.8);
  background-color: #fff;
}
.el-button--primary:focus, .el-button--primary:hover {
  background-color: rgba(220, 20, 60, 0.8);
  border-color: rgba(220, 20, 60, 0.1);
  color: #fff;
}
.el-input.is-active .el-input__inner, .el-input__inner:focus {
  border-color: rgb(220, 20, 60);
}
.el-upload-list__item.is-success .el-upload-list__item-name:focus, .el-upload-list__item.is-success .el-upload-list__item-name:hover {
  color: rgb(220, 20, 60);
}
.el-button--danger {
  border-color: #ff8c00;
  background-color: #ff8c00;
}
.el-button--danger:focus, .el-button--danger:hover {
  background-color: rgba(255,140,0,0.8);
  border-color: rgba(255,140,0,0.8);
  color: #FFF;
}
.el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
  color: #FFF;
  background-color: rgba(220, 20, 60, 0.5);
  border-color: rgba(220, 20, 60, 0.1);
}
.el-pager li:hover, .el-pagination button:hover, .el-pager li.active, .el-date-table td.today span, .el-date-table td.available:hover, .el-button--text, .el-time-panel__btn.confirm, .el-picker-panel__icon-btn:hover, .el-select-dropdown__item.selected {
  color: rgb(220, 20, 60);
}
.el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner {
  border-color: rgb(220, 20, 60);
}
.el-date-table td.end-date span, .el-date-table td.start-date span {
    background-color: rgb(220, 20, 60);
}
.el-button.is-plain:focus, .el-button.is-plain:hover {
    background: #FFF;
    border-color: rgb(220, 20, 60);
    color: rgb(220, 20, 60);
}
.el-table--border {
  border-radius: 4px;
}
.source-wrapper {
  .el-form-item {
    display: inline-block;
  }
}

</style>




// WEBPACK FOOTER //
// src/App.vue